import React, { Fragment, useContext, useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isFetching, setInviteUserModal } from "store/users/actions";
import { AbilityContext } from "config/Can";
import MetisMenu from "react-metismenu";
import { MainNav } from "../../config/NavItems";
import { useAbility } from "@casl/react";
import { Badge, Button } from "reactstrap";
import { fetchAllCustomers } from "store/customer/actions";
import createJobSelector from "store/job/selector";
import { useHistory } from "react-router-dom";
import {
  callMonitoring,
  fetchAllJobs,
  fetchAllMemo,
  fetchAllServices,
  fetchNotifications,
  callUnsavedOption,
} from "store/job/actions";
import { FetchAllEquipment } from "store/equipment/actions";
import AlertModel from "components/JobManagement/common/AlertModal";

const Nav = ({ location }) => {
  const ability = useAbility(AbilityContext);
  const userData = JSON.parse(localStorage.getItem("user"));
  const { id, role } = userData;
  const dispatch = useDispatch();
  const jobSelector = useSelector(createJobSelector);
  const { totalServices, allMemo, AllJobs, isUnsavedOption } = jobSelector;
  const filteredNav = MainNav.filter((item) => {
    if (item.label === "Viper + Ad") {
      return ability.can("read", "Owner") || role === "Owner";
    }

    if (item.label === "New Bulletin" || item.to === "/bulletin") {
      return ability.can("read", "Owner") || role === "Owner";
    }

    // Technician menu
    if (ability.can("read", "Technician")) {
      return [
        "ALL JOBS",
        "DASHBOARD",
        "NEW EQUIPMENT",
        "WATCH AND ACT",
        "MEMO"
      ].includes(item.label);
    }

    // Admin → all other items except Owner-only items
    if (ability.can("read", "Admin")) {
      return item.to !== "/bulletin" && item.label !== "New Bulletin" && item.label !== "Viper + Ad";
    }

    return true;
  });


  // Model open

  const [modalOpen, setModalOpen] = useState(false);
  const [targetRoute, setTargetRoute] = useState("");
  const history = useHistory();

  const handleConfirm = () => {
    setModalOpen(false);
    if (history && typeof history.push === "function") {
      dispatch(callUnsavedOption(false));
      history.push(targetRoute);
    } else {
      console.error("History.push is not a function");
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    dispatch(fetchAllJobs(true));
    dispatch(fetchAllServices(true));
    dispatch(fetchAllCustomers(true));
    dispatch(fetchAllMemo(true));
    dispatch(FetchAllEquipment(true));
    dispatch(fetchNotifications(true));
  }, [dispatch]);

  const CustomLink = ({
    hasSubMenu,
    activateMe,
    toggleSubMenu,
    className,
    children,
    to,
  }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const jobSelector = useSelector(createJobSelector);
    const { totalServices, allMemo, AllJobs, isUnsavedOption } = jobSelector;
    const [totalWatchandAct, setTotalWatchAndAct] = useState([]);
    const [totalAllMemo, settotalAllMemo] = useState([]);
    const [totalServiceCount, setTotalServiceCount] = useState();

    const onClick = (e) => {
      if (e.target.innerText === "TECHNICIAN") {
        dispatch(isFetching(true));
      } else if (e.target.innerText === "CUSTOMER") {
        dispatch(fetchAllCustomers(true));
      } else {
        dispatch(fetchAllJobs(true));
        dispatch(setInviteUserModal(false));
        dispatch(isFetching(true));
        dispatch(fetchAllServices(true));
        // dispatch(fetchAllCustomers(true));
        dispatch(fetchAllMemo(true));
        dispatch(FetchAllEquipment(true));
        dispatch(fetchNotifications(true));
      }
      if (hasSubMenu) toggleSubMenu(e);
      else {
        activateMe(e);
      }
      if (isUnsavedOption) {
        e.preventDefault();
        setModalOpen(true);
        setTargetRoute(to);
      } else {
        activateMe(e);
      }
    };

    const getButtonColor = () => {
      switch (to) {
        case "/dashboard":
          return "secondary";
        case "/technicians":
          return "info";
        case "/customers":
          return "warning";
        case "/new-installation":
          return "info";
        case "/new-equipment":
          return "danger";
        case "/new-removal":
          return "success";
        case "/new-relocation":
          return "warning";
        case "/change-of-equipment":
          return "success";
        case "/services":
          return "danger";
        case "/jobs":
          return "primary";
        case "/watch-act":
          return "secondary";
        case "/memo":
          return "warning";
        case "/email-template":
          return "dark";
        case "/viper-ads":
          return "gray";
        case "/bulletin":
          return "info";
        default:
          return "gray";
      }
    };

    const getBadgeInfo = () => {
      let badgeInfo = { showBadge: false, badgeNumber: 0 };
      if (to === "/watch-act") {
        badgeInfo = { showBadge: true, badgeNumber: totalWatchandAct.length };
      } else if (to === "/services") {
        badgeInfo = { showBadge: true, badgeNumber: totalServiceCount };
      } else if (to === "/memo") {
        badgeInfo = { showBadge: true, badgeNumber: totalAllMemo.length };
      }
      return badgeInfo;
    };

    const { showBadge, badgeNumber } = getBadgeInfo();

    useEffect(() => {
      try {
        const filterServices = totalServices.filter((value) => {
          if (
            role === "Admin" ||
            role === "Owner" ||
            value.technicians_id === id
          )
            return value.resolution?.watchAct;
        });
        setTotalWatchAndAct(filterServices);
      } catch (error) {
        console.error("Error fetching notifations:", error);
      }
    }, [totalServices]);

    useEffect(() => {
      const filterJobs = (job) => {
        const isServiceJob =
          job.jobType === "Services" && job.status !== "Processed";
        if (ability.can("read", "Admin") || ability.can("read", "Owner")) {
          return isServiceJob;
        } else if (
          ability.can("read", "Technician") &&
          job.technicians_id === id
        ) {
          return isServiceJob;
        }
        return false;
      };

      const newFilteredData = AllJobs.filter(filterJobs);

      setTotalServiceCount(newFilteredData.length);
    }, [AllJobs, ability, id]);

    useEffect(() => {
      const userData = JSON.parse(localStorage.getItem("user"));
      const { id, role } = userData;
      try {
        const filterMemo = allMemo.filter((value) => {
          if (role === "Admin" || value.memoOwnerId === id) {
            return value;
          } else if (role === "Technician") {
            return value.visibility !== "Admin";
          }
        });
        settotalAllMemo(filterMemo);
      } catch (error) {
        console.error("Error fetching notifations:", error);
      }
    }, [allMemo]);

    return (
      <>
        <div className="position-relative">
          <Link to={to} onClick={onClick}>
            <Button
              className={`${className} mt-3`}
              color={getButtonColor()}
              type="button"
              style={{
                border: "none",
                width: "100%",
                textAlign: "start",
                color: "white",
                background:
                  to === "/change-of-equipment"
                    ? "#FF4433"
                    : to === "/sms-template"
                      ? "#800000"
                      : to === "/myspy-app-dashboard"
                        ? "#584AD3"
                        : to === "/viper-ads"
                          ? "#c300ffce"
                          : to === "/bulletin"
                            ? "#188fffff"
                            : ""
              }}
            >
              {children}
            </Button>
          </Link>
          {showBadge && (
            <Badge
              color="danger"
              style={{
                position: "absolute",
                top: "-5px",
                right: "-6px",
                cursor: "pointer",
                borderRadius: "50%",
                padding: "3px",
                fontSize: "12px",
                "@media (max-width: 768px)": {
                  right: "30px",
                },
              }}
              onClick={() => {
                if (to === "/services") {
                  history.push("/jobs", { isService: true });
                } else if (to === "/memo") {
                  history.push("/memo", { isMemoList: true });
                } else if (to === "/watch-act") {
                  history.push("/watch-act");
                }
              }}
            >
              {badgeNumber}
            </Badge>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {isUnsavedOption && (
        <AlertModel
          isOpen={modalOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      {/* <h5 className="app-sidebar__heading">Menu</h5> */}
      <MetisMenu
        activeLinkFromLocation
        content={filteredNav}
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
        LinkComponent={CustomLink}
      />
    </>
  );
};

export default withRouter(Nav);
